import React, { CSSProperties } from 'react';

import { Genre } from '../../types/types';

interface PropTypes {
  style?: CSSProperties;
  data: Genre;
  onClick?: () => void;
  className?: string;
}

function GenreItem({ data, onClick, className }: PropTypes) {
  return (
    <div
      className={`flex justify-center items-center rounded-md px-4 w-[100px] md:w-[130px] h-[100px] md:h-[130px] bg-black text-white hover:bg-gray-200 ${className}`}
      onClick={onClick}
    >
      <span className="text-center text-xs md:text-sm font-bold text-white">
        {data.name}
      </span>
    </div>
  );
}

export default GenreItem;
